import { SJT_SALES_ITEMS } from "./questionBank.js";
import { scoreSJT_SALES, SJT_SALES_NORMS, SJT_SALES_BANDS, SJT_SALES_DIMENSIONS } from "./scoring.js";
export { SJT_SALES_NORMS, SJT_SALES_BANDS, SJT_SALES_DIMENSIONS };

const SalesSJT = {
  id:"sjt_sales", name:"Sales Aptitude SJT", shortName:"Sales SJT",
  icon:"📈", color:"#0891b2", bg:"#ecfeff",
  description:"20 field sales scenarios assessing objection handling, pipeline management, client trust, negotiation, resilience and ethics. Validated against Indian BFSI, Pharma, FMCG and insurance sales professionals. Identifies high-potential sales talent for volume hiring.",
  desc:"20 scenarios · Most/Least format · 20 minutes · Auto-scored",
  publisher:"AXIS360 Express", version:"1.0",
  itemCount:20, items:20, timeLimit:20, time:"20 min", timeEstimate:"20 minutes",
  format:"sjt", isSJT:true, isExpress:true, pricingTier:"volume", creditCost:20,
  predicts:["First-year sales performance","Revenue attainment vs quota","Client retention rates","Ramp time to target"],
  questions: SJT_SALES_ITEMS,
  score(answers) {
    const most  = answers.most  || answers;
    const least = answers.least || new Array(SJT_SALES_ITEMS.length).fill(null);
    return scoreSJT_SALES(most, least);
  },
  nineboxAxes:{ x:{label:"Sales Judgement",scaleIds:["sjt_sales"]}, y:{label:"Sales Judgement",scaleIds:["sjt_sales"]} },
};
export default SalesSJT;
